(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/ball-row-play/assets/javascripts/ball-row-play-keno.js') >= 0) return;  svs.modules.push('/components/tur/ball-row-play/assets/javascripts/ball-row-play-keno.js');
'use strict';

svs.tur = svs.tur || {};
svs.tur.ball = svs.tur.ball || {};
svs.tur.ball.row = svs.tur.ball.row || {};
svs.tur.ball.row.play = svs.tur.ball.row.play || {};
class Keno extends svs.tur.ball.row.play.Default {
  constructor() {
    let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      align = _ref.align,
      _ref$numbers = _ref.numbers,
      numbers = _ref$numbers === void 0 ? 11 : _ref$numbers,
      _ref$kungKeno = _ref.kungKeno,
      kungKeno = _ref$kungKeno === void 0 ? false : _ref$kungKeno,
      _ref$isSystem = _ref.isSystem,
      isSystem = _ref$isSystem === void 0 ? false : _ref$isSystem,
      isValid = _ref.isValid,
      isActive = _ref.isActive,
      isEmpty = _ref.isEmpty,
      winPlan = _ref.winPlan,
      size = _ref.size;
    const _numbers = isSystem ? 0 : numbers,
      _kungKeno = kungKeno;
    const row = new svs.tur.ball.row.Keno({
      align,
      numbers: _numbers,
      kungKeno: _kungKeno,
      addEmptyBall: false,
      winPlan,
      size
    });
    super({
      row,
      _numbers,
      _kungKeno,
      isSystem,
      isValid,
      isActive,
      isEmpty
    });
  }
  classNames() {
    return ['ball-row-play-keno'];
  }
  setKenoLevel() {
    let level = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 11;
    const tl = gsap.timeline();
    this.levelTL = tl;
    if (this._numbers === level) {
      this.log.info("You cannot set the same level twice.");
    } else if (this._numbers > level) {
      for (let j = this._numbers - 1; j >= level; j--) {
        const ballTL = this.row.remove({
          index: j
        });
        tl.add(ballTL, '<.03');
      }
      this._numbers = level;
    } else if (this._numbers < level) {
      const diff = level - this._numbers;
      for (let i = 0; i < diff; i++) {
        const ballTL = this.row.add({
          empty: true
        });
        tl.add(ballTL, i ? "-=".concat(ballTL.duration() * 0.8) : '');
      }
      this._numbers = level;
    }
  }
  addHuxfluxed(obj) {
    if (this.levelTL && this.levelTL.isActive()) {
      this.levelTL.call(() => super.addHuxfluxed(obj));
    } else {
      super.addHuxfluxed(obj);
    }
  }
  toggleKungKeno() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.row.kungKeno;
    if (state !== this.row.kungKeno) {
      const tl = gsap.timeline();
      if (state) {
        this.row.toggleKungKeno(true);
        const el = this.row.ballKungKeno.$el,
          width = this.row.ballKungKeno.getAbsoluteWidth(el);
        CustomBounce.create('ballBounce', {
          strength: 0.6,
          squash: 2,
          squashID: 'ballBounce-squash'
        });
        tl.fromTo(el, {
          width: 0
        }, {
          duration: 0.1,
          width
        });
        tl.to(el, 0.2, {
          y: -30,
          scale: 1,
          rotation: -30
        }, '-=.1');
        tl.to(el, 0.6, {
          y: 0,
          rotation: 0,
          ease: 'ballBounce'
        }).to(el, 0.6, {
          scaleX: 1.2,
          scaleY: 0.7,
          ease: 'ballBounce-squash',
          transformOrigin: 'center bottom'
        }, '-=0.6');
        tl.set(el, {
          clearProps: 'all'
        });
      } else {
        if (this.row.ballKungKeno) {
          tl.add(this.row.ballKungKeno.shrink());
          tl.call(() => {
            this.row.toggleKungKeno(false);
          });
        }
      }
    }
  }
}
svs.tur.ball.row.play.Keno = Keno;

 })(window);